import { Button } from "@ts-digital/vrc";
import React from "react";
import { FormattedMessage } from "react-intl";
import VaporDrawer from "../../../general/vapor/drawer";
import GoodsDrawer from "./drawer/goodsDrawer";
import ServicesDrawer from "./drawer/servicesDrawer";
import "./style.css";

const DrawerAddNomenclaturaIntrastat = ({conto, onClose, visible, isSaleInvoice, draftId}) => {

  return (
    <VaporDrawer
      onClose={onClose}
      visible={visible}
      title={<div className="dbx-preCog-intrastat-add-nomenclatura-title" style={{ width: 700 }}>{conto.nomenclatura}</div>}
      subtitle={<div className="dbx-preCog-intrastat-add-nomenclatura-subtitle" style={{ width: 700 }}><FormattedMessage id="preCog.intrastatTab.description" /></div>}
      width={800}
      maskClosable={false}
      buttons={[
        <Button key={`secondaryBtn_${conto.nomenclatura}`} kind='secondary' onClick={() => onClose()}><FormattedMessage id="actions.close" /></Button>,
        <Button key={`primaryBtn_${conto.nomenclatura}`} kind='primary'><FormattedMessage id="actions.save" /></Button>
      ]}
    >
      {conto.type === "GOOD" ? <GoodsDrawer isSaleInvoice={isSaleInvoice} draftId={draftId} id={conto.id} model={conto.model} /> : <ServicesDrawer draftId={draftId} id={conto.id} model={conto.model} />}
    </VaporDrawer>
  );
};

export default DrawerAddNomenclaturaIntrastat;
